import React, { useState } from 'react';
import WebModal from '../Modal';
import BottomDrawer from '../BottomDrawer';
import UpdataContent from './updataContent';
import { useTranslation } from 'react-i18next';
import { isMobile } from '@/biz/tool';

interface Props {
  showModalUpdataAudience: boolean;
  setShowModalUpdataAudience: (showModalUpdataAudience: boolean) => void;
  uploadCallback: () => void;
}

const ModalUpdataAudience: React.FC<Props> = ({
  showModalUpdataAudience,
  setShowModalUpdataAudience,
  uploadCallback
}) => {
  const { t } = useTranslation();

  const title = t(
    'modal.modal_take_order.audience_demographics.share_audience_insights',
    { defaultValue: 'Share audience insights' }
  );

  const handleClose = () => setShowModalUpdataAudience(false);

  const content = (
    <UpdataContent
      onClose={() => {
        setShowModalUpdataAudience(false);
      }}
      onSuccess={uploadCallback}
    />
  );

  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          title={<div className="mt-3 text-lg font-semibold">{title}</div>}
          visible={showModalUpdataAudience}
          handleClose={handleClose}
          isShowFooter={false}
        >
          <div className="flex flex-col overflow-y-auto">{content}</div>
        </BottomDrawer>
      ) : (
        <WebModal
          visible={showModalUpdataAudience}
          title={<div className="text-2xl font-semibold">{title}</div>}
          isShowFooter={false}
          disablePortal={false}
          canClose={true}
          handleClose={handleClose}
          width={820}
          className="!z-[9999]"
        >
          {content}
        </WebModal>
      )}
    </>
  );
};

export default ModalUpdataAudience;
